import { combineReducers } from 'redux';
import timers from './timers';

export default combineReducers({
    timers
})